import store from '../store/index'

export const initAudio = (elem) => {
  if (elem.spirit && elem.spirit.src) {
    return elem.spirit
  } else {
    const audio = new Audio()
    audio.src = elem.musicUrl
    audio.loop = true
    return audio
  }
}

export const playAudio = (elem) => {
  elem.spirit = initAudio(elem)
  elem.isOpen && elem.spirit.play()
}

export const pauseAudio = (elem) => {
  if (!store.state.isPlay) { return false }
  elem.spirit.pause()
  elem.spirit.currentTime = 0
}
